import {useEffect, useState, useMemo, useCallback} from "react";
import {useParams, useLocation, useSearchParams} from "react-router-dom";
import {useAppState} from "../../context/state";

export default function useUrlRef() {
  const [urlRef, setUrlRef] = useState<string>();
  const params = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const locationState = useMemo(
    () => (location.state || {}) as Record<string, any>,
    [location.state]
  );
  const {appState, setAppState} = useAppState();
  const lsUrlRef = localStorage.getItem("urlRef");
  const searchParamRef = searchParams.get("campaignRef");

  const updateUrlRef = useCallback(
    (newUrlRef: string) => {
      const casted = String(newUrlRef);
      const cleanUrlRef = casted.substring(casted.lastIndexOf('/') + 1).replace("/", "");
      setAppState((old) => ({...(old || {}), url: cleanUrlRef}));
      localStorage.setItem("urlRef", cleanUrlRef);
      setUrlRef(cleanUrlRef);
    },
    [setAppState]
  );

  useEffect(() => {
    let output: string = "";
    if (params.campaignRef) {
      output = params.campaignRef;
    } else if (locationState.urlRef) {
      output = locationState.urlRef;
    } else if (appState?.url) {
      output = appState.url;
    } else if (lsUrlRef) {
      output = lsUrlRef;
    } else if (searchParamRef) {
      output = searchParamRef;
    }
    const casted = String(output);
    const cleanUrlRef = casted.substring(casted.lastIndexOf('/') + 1).replace("/", "");

    setUrlRef(cleanUrlRef);
    localStorage.setItem("urlRef", cleanUrlRef);
  }, [
    params,
    locationState?.urlRef,
    searchParams,
    lsUrlRef,
    searchParamRef,
    location.pathname,
    updateUrlRef,
  ]);

  return useMemo(
    () => ({urlRef, setUrlRef: updateUrlRef}),
    [urlRef, updateUrlRef]
  );
}
